var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"115bcf63fa8398adf326a2323ea80ca61b317d41"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

// This file configures the intialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
// https://docs.sentry.io/platforms/javascript/guides/nextjs/performance/instrumentation/automatic-instrumentation/

import { BrowserTracing, init as sentryInit } from '@sentry/nextjs'
import { reactRouterV5Instrumentation } from '@sentry/react'
import { IS_SENTRY_SET, SENTRY_DSN } from './src/constants/common'
import { getEnv } from './src/utils/environment'
import { browserHistory } from './src/utils/history'

if (IS_SENTRY_SET) {
  const farosApiUrl = new URL(getEnv('NEXT_PUBLIC_FAROS_API_URL'))
  sentryInit({
    release: process.env.GIT_COMMIT,
    dsn: SENTRY_DSN,
    environment: getEnv('NEXT_PUBLIC_SENTRY_ENVIRONMENT'),
    debug: getEnv('NEXT_PUBLIC_SENTRY_DEBUG_LOG_LEVEL_ENABLED') === 'true',
    tracesSampleRate:
      parseFloat(getEnv('NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE')) || 1.0,
    integrations: [
      new BrowserTracing({
        // do we need to keep "localhost" - the default setting?
        tracePropagationTargets: ['localhost', /^\//, farosApiUrl.host],
        finalTimeout:
          parseInt(getEnv('NEXT_PUBLIC_SENTRY_FINAL_TIMEOUT')) || 60001,
        heartbeatInterval:
          parseInt(getEnv('NEXT_PUBLIC_SENTRY_HEARTBEAT_INTERVAL')) || 20000,
        routingInstrumentation: reactRouterV5Instrumentation(browserHistory),
      }),
    ],
    ignoreErrors: [
      // https://github.com/getsentry/sentry-javascript/issues/3440#issuecomment-865857552
      'Non-Error promise rejection captured',
      // Non-actionable timeout from third-party reCAPTCHA script during auth flows
      'reCAPTCHA Timeout',
      // Non-actionable 403s from the Frontegg SDK's internal saveProfile /
      // admin-portal flows (expired sessions, SCIM-managed users, etc.).
      // Error shape comes from @frontegg/rest-api FetchClient: `Error ${status} - ${statusText}`.
      /^Error 403 -\s*$/,
    ],
    // Filter out third-party noise from the Google Identity Services (GSI)
    // client bundle. URL-based matching is preferred over message-based
    // filters so that legitimate application errors are preserved.
    denyUrls: [/^https?:\/\/accounts\.google\.com\/gsi\/client/i],
    sendDefaultPii: true,
  })
}
